<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [showHeader]="false"
  appendTo="self"
  styleClass="ca-dialog-frame"
  [style]="{width: '1170px', maxWidth: '94vw'}"
  data-testid="rfi-coverage-analysis-dialog"
>
  <div class="flex h-[min(820px,85vh)] flex-col">
    <div class="border-themed flex items-center justify-between gap-4 border-b px-5 py-4">
      <div class="flex flex-col">
        <h3 class="text-xl font-semibold">
          {{ 'project.steps.rfi.invitationList.analysis.title' | transloco: titleParams() }}
        </h3>
        <span class="text-muted-color text-sm">
          {{ 'project.steps.rfi.invitationList.analysis.subtitle' | transloco }}
        </span>
      </div>
      <button
        type="button"
        class="text-muted-color px-1 text-xl hover:text-red-400"
        [attr.aria-label]="'common.close' | transloco"
        (click)="close()"
        data-testid="analysis-close-icon"
      >
        ✕
      </button>
    </div>

    @if (view(); as analysis) {
      <div class="border-themed flex flex-wrap gap-1 border-b px-5" role="tablist">
        @for (tab of tabItems(); track tab.id) {
          <button
            type="button"
            role="tab"
            [class]="tab.cssClass"
            [attr.aria-selected]="tab.active"
            (click)="showTab(tab.id)"
            [attr.data-testid]="'analysis-tab-' + tab.id"
          >
            {{ tab.labelKey | transloco }}
            @if (tab.count !== null) {
              ({{ tab.count }})
            }
          </button>
        }
      </div>

      <div class="flex-1 overflow-auto px-5 py-[18px]">
        @switch (activeTab()) {
          @case ('overview') {
            <app-coverage-overview-tab [view]="analysis" (tabRequested)="showTab($event)" />
          }
          @case ('gaps') {
            <app-coverage-gaps-tab [view]="analysis" (tabRequested)="showTab($event)" />
          }
          @case ('countries') {
            <app-coverage-countries-tab [view]="analysis" />
          }
          @case ('matrix') {
            <app-coverage-matrix-tab [view]="analysis" />
          }
          @case ('extras') {
            <app-coverage-extras-tab [view]="analysis" />
          }
          @case ('calculation') {
            <app-coverage-calculation-tab [view]="analysis" />
          }
        }
      </div>
    }

    <div class="border-themed flex items-center justify-between gap-4 border-t px-5 py-3">
      <span class="text-muted-color text-sm">
        {{ 'project.steps.rfi.invitationList.analysis.footerNote' | transloco }}
      </span>
      <p-button
        [label]="'common.close' | transloco"
        severity="secondary"
        size="small"
        (onClick)="close()"
        data-testid="analysis-close"
      />
    </div>
  </div>
</p-dialog>
